export default __webpack_public_path__ + "static/app_screenshot_1-2646e2c91605c6abda635731f8ea7fef.webp";